import { Result, Button } from 'antd';
import { HomeOutlined, RobotOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <Result
      status="404"
      icon={<RobotOutlined />}
      title="Page not found"
      subTitle="That route isn't wired up yet, or the link you followed is stale."
      extra={
        <Link to="/">
          <Button type="primary" icon={<HomeOutlined />}>
            Back to dashboard
          </Button>
        </Link>
      }
      style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    />
  );
}
